module.exports = __webpack_public_path__ + "img/delete.5f5d3389.svg";